import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "choerodon-ui/lib/configure/style";
import _configure from "choerodon-ui/lib/configure";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "choerodon-ui/lib/get-config/style";
import _getConfig from "choerodon-ui/lib/get-config";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _isPlainObject from "lodash/isPlainObject";
import _set from "lodash/set";
import _isUndefined from "lodash/isUndefined";
import _isEmpty from "lodash/isEmpty";

/**
 * choerodon-ui - choerodon-ui 客制化配置文件
 * @Author: wuyunqiang <yunqiang.wu@hand-china.com>
 * @Date: 2019-08-15 09:12:30
 * @LastEditTime: 2019-08-27 09:47:01
 * @Copyright: Copyright (c) 2018, Hand
 */
import axios from 'axios';
import { getConfig } from 'hzero-boot';
import { routerRedux } from 'dva/router';
import qs from 'query-string';
import intl from "./intl";
import notification from "./notification";
import { generateUrlWithGetParam, getAccessToken, getCurrentOrganizationId, isTenantRoleLevel, getRequestId, setSession, getSession, isEqualOrganization, getCurrentUserId } from "./utils";
import { getEnvConfig, getDvaApp } from "./iocUtils";
import { HighLightRowType, TableQueryBarType } from 'choerodon-ui/pro/lib/table/enum';
import Attachment from "../components/Attachment";
import noDataImg from "../assets/page-icons/noData.png"; // import request from 'utils/request';

import React from 'react';
import { $l } from 'choerodon-ui/pro/lib/locale-context';
import { FieldType } from 'choerodon-ui/dataset/data-set/enum';
import { getMenuId } from "./menuTab";
var lovDefineAxiosConfig = function lovDefineAxiosConfig(code, field) {
  var _getEnvConfig = getEnvConfig(),
    API_HOST = _getEnvConfig.API_HOST,
    HZERO_PLATFORM = _getEnvConfig.HZERO_PLATFORM;
  var publicFlag = false;
  if (field === null || field === void 0 ? void 0 : field.get('lovPara')) {
    var _field$get = field.get('lovPara'),
      publicMode = _field$get.publicMode;
    publicFlag = publicMode;
  }
  return {
    url: "".concat(API_HOST).concat(HZERO_PLATFORM, "/v1/").concat(
    // eslint-disable-next-line no-nested-ternary
    publicFlag ? 'pub/' : isEqualOrganization() ? "".concat(getCurrentOrganizationId(), "/") : '', "lov-view/info?viewCode=").concat(code),
    method: 'GET',
    transformResponse: [function (data) {
      // 对 data 进行任意转换处理
      var originData = {};
      try {
        originData = JSON.parse(data);
      } catch (e) {
        console.error(e, data);
        return data;
      }
      var _originData = originData,
        height = _originData.height,
        _originData$viewCode = _originData.viewCode,
        viewCode = _originData$viewCode === void 0 ? code : _originData$viewCode,
        _originData$valueFiel = _originData.valueField,
        valueField = _originData$valueFiel === void 0 ? 'value' : _originData$valueFiel,
        _originData$displayFi = _originData.displayField,
        displayField = _originData$displayFi === void 0 ? 'name' : _originData$displayFi,
        _originData$pageSize = _originData.pageSize,
        pageSize = _originData$pageSize === void 0 ? 5 : _originData$pageSize,
        _originData$queryFiel = _originData.queryFields,
        queryFields = _originData$queryFiel === void 0 ? [] : _originData$queryFiel,
        _originData$tableFiel = _originData.tableFields,
        tableFields = _originData$tableFiel === void 0 ? [] : _originData$tableFiel,
        childrenFieldName = _originData.childrenFieldName,
        mustPageFlag = _originData.mustPageFlag;
      var _originData2 = originData,
        title = _originData2.title;
      if (originData.failed) {
        title = intl.get('hzero.common.c7n.lov.notDefine', {
          code: code
        }).d("\u503C\u96C6\u89C6\u56FE\u672A\u5B9A\u4E49: \"".concat(code, "\", \u8BF7\u7EF4\u62A4\u503C\u96C6\u89C6\u56FE!"));
      } else if (!originData.lovCode) {
        title = "lov ".concat(code, " loading...");
      }
      var lovItems = []; // let tableWidth = 0;

      queryFields.forEach(function () {
        var queryItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var lovItem = {
          lovId: viewCode,
          lovItemId: "query_".concat(queryItem.field),
          gridFieldName: queryItem.field,
          gridField: 'N',
          display: queryItem.label,
          autocompleteField: 'Y',
          conditionField: 'Y',
          isAutocomplete: 'N',
          conditionFieldWidth: null,
          conditionFieldLabelWidth: null,
          conditionFieldType: queryItem.dataType === 'LOV_CODE' ? 'object' : queryItem.dataType,
          conditionFieldSelectCode: queryItem.dataType === 'SELECT' ? queryItem.sourceCode : null,
          conditionFieldLovCode: queryItem.dataType === 'LOV_CODE' ? queryItem.sourceCode : null,
          conditionFieldName: null,
          conditionFieldTextfield: null,
          conditionFieldNewline: 'N',
          conditionFieldSelectUrl: null,
          conditionFieldSelectVf: null,
          conditionFieldSelectTf: null,
          conditionFieldSequence: 1,
          gridFieldSequence: 1
        };
        lovItems.push(lovItem);
      });
      tableFields.forEach(function (tableItem) {
        var lovItem = {
          lovId: viewCode,
          lovItemId: "table_".concat(tableItem.dataIndex),
          gridFieldName: tableItem.dataIndex,
          gridFieldWidth: tableItem.width,
          gridFieldAlign: 'left',
          autocompleteField: 'Y',
          conditionField: 'N',
          isAutocomplete: 'N',
          gridField: 'Y',
          display: tableItem.title,
          conditionFieldWidth: null,
          conditionFieldLabelWidth: null,
          conditionFieldType: null,
          conditionFieldSelectCode: null,
          conditionFieldName: null,
          conditionFieldTextfield: null,
          conditionFieldNewline: 'N',
          conditionFieldSelectUrl: null,
          conditionFieldSelectVf: null,
          conditionFieldSelectTf: null,
          conditionFieldLovCode: null,
          conditionFieldSequence: 1,
          gridFieldSequence: 1
        };
        lovItems.push(lovItem); // tableWidth += tableItem.width;
      });

      return {
        originData: _objectSpread({
          lovCode: code
        }, originData),
        code: viewCode,
        title: title,
        description: title,
        lovId: viewCode,
        sqlId: viewCode,
        customSql: null,
        queryColumns: 2,
        customUrl: null,
        textField: displayField,
        valueField: valueField,
        delayLoad: 'N',
        needQueryParam: 'N',
        editableFlag: 'Y',
        canPopup: 'Y',
        lovPageSize: mustPageFlag === 0 ? undefined : pageSize,
        treeFlag: _isUndefined(childrenFieldName) ? 'N' : 'Y',
        idField: _isUndefined(childrenFieldName) ? null : valueField,
        parentIdField: _isUndefined(childrenFieldName) ? null : childrenFieldName,
        lovItems: lovItems,
        width: 710,
        height: height
      };
    }]
  };
};
var loadConfig = function loadConfig() {
  var _getEnvConfig2 = getEnvConfig(),
    configureParams = _getEnvConfig2.configureParams,
    API_HOST = _getEnvConfig2.API_HOST,
    HZERO_PLATFORM = _getEnvConfig2.HZERO_PLATFORM,
    HZERO_OAUTH = _getEnvConfig2.HZERO_OAUTH;
  var lookupAxiosConfig = function lookupAxiosConfig(_ref) {
    var params = _ref.params,
      lookupCode = _ref.lookupCode;
    var publicFlag = false;
    var lovParams = {};
    if (params) {
      var publicMode = params.publicMode,
        other = _objectWithoutProperties(params, ["publicMode"]);
      publicFlag = publicMode;
      lovParams = other;
    }
    return {
      url: lookupCode ? "".concat(API_HOST).concat(HZERO_PLATFORM, "/v1/").concat(
      // eslint-disable-next-line no-nested-ternary
      publicFlag ? 'pub/' : isEqualOrganization() ? "".concat(getCurrentOrganizationId(), "/") : '', "lovs/data?lovCode=").concat(lookupCode) : undefined,
      method: 'GET',
      params: lovParams,
      transformResponse: function transformResponse(data) {
        // 对 data 进行任意转换处理
        var originData = data || [];
        if (typeof data === 'string') {
          try {
            originData = JSON.parse(data);
          } catch (e) {
            originData = data;
          }
        }
        return originData;
      }
    };
  };
  var lovQueryAxiosConfig = function lovQueryAxiosConfig(code) {
    var _dataSet$queryDataSet, _dataSet$queryDataSet2, _dataSet$queryDataSet3;
    var lovConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var props = arguments.length > 2 ? arguments[2] : undefined;
    var lovQueryUrl = arguments.length > 3 ? arguments[3] : undefined;
    var _ref2 = lovConfig.originData || {},
      queryUrl = _ref2.queryUrl,
      lovCode = _ref2.lovCode,
      lovTypeCode = _ref2.lovTypeCode,
      _ref2$requestMethod = _ref2.requestMethod,
      requestMethod = _ref2$requestMethod === void 0 ? 'GET' : _ref2$requestMethod;
    var data = props.data,
      dataSet = props.dataSet;
    var queryData = (_dataSet$queryDataSet = dataSet.queryDataSet) === null || _dataSet$queryDataSet === void 0 ? void 0 : (_dataSet$queryDataSet2 = _dataSet$queryDataSet.current) === null || _dataSet$queryDataSet2 === void 0 ? void 0 : _dataSet$queryDataSet2.toData();
    (_dataSet$queryDataSet3 = dataSet.queryDataSet) === null || _dataSet$queryDataSet3 === void 0 ? void 0 : _dataSet$queryDataSet3.fields.forEach(function (field) {
      if (queryData[field.get('name')] && field.get('type') === "object" && _isPlainObject(data[field.get('name')])) {
        var _queryData$field$get;
        _set(data, field.get('name'), (_queryData$field$get = queryData[field.get('name')]) === null || _queryData$field$get === void 0 ? void 0 : _queryData$field$get[field.get('valueField')]);
      }
    });
    var url = "".concat(API_HOST).concat(HZERO_PLATFORM, "/v1/").concat(isTenantRoleLevel() ? "".concat(getCurrentOrganizationId(), "/") : '', "lovs/data?").concat(lovTypeCode === 'URL' ? '' : "lovCode=".concat(lovCode));
    if (lovQueryUrl) {
      url = lovQueryUrl;
    } else if (queryUrl) {
      url = generateUrlWithGetParam(queryUrl, lovTypeCode === 'URL' ? {} : {
        lovCode: lovCode
      });
      var organizationRe = /{organizationId}|{tenantId}/g;
      if (organizationRe.test(url)) {
        var tId = getCurrentOrganizationId();
        url = url.replace(organizationRe, tId);
      }
      if (!_isEmpty(data)) {
        Object.keys(data).forEach(function (key) {
          var lovParamsRe = RegExp("({)".concat(key, "(})"), 'g');
          if (lovParamsRe.test(url)) {
            var val = data[key];
            url = url.replace(lovParamsRe, val);
          }
        });
      } // url = `${url}${url.indexOf('?') ? '&' : '?'}lovCode=${lovCode}`;
    }

    return {
      url: url,
      method: requestMethod
    };
  }; // TODO: 批量查询lookupCode只支持独立值集，sql类型的暂时不考虑

  var lookupBatchAxiosConfig = function lookupBatchAxiosConfig(codes) {
    var url = "".concat(API_HOST).concat(HZERO_PLATFORM, "/v1/").concat(isTenantRoleLevel() ? "".concat(getCurrentOrganizationId(), "/") : '', "lovs/value/batch");
    return {
      url: url,
      method: 'GET',
      params: codes.reduce(function (obj, code) {
        // eslint-disable-next-line
        obj[code] = code;
        return obj;
      }, {})
    };
  };
  var generatePageQuery = function generatePageQuery(_ref3) {
    var page = _ref3.page,
      pageSize = _ref3.pageSize,
      sortName = _ref3.sortName,
      sortOrder = _ref3.sortOrder,
      sort = _ref3.sort;
    var sortParams = sort ? {
      sort: sort
    } : {
      sort: sortName && (sortOrder ? "".concat(sortName, ",").concat(sortOrder) : sortName)
    };
    return _objectSpread({}, sortParams, {
      page: page === undefined ? page : page - 1,
      size: pageSize
    });
  };
  /**
   * 鉴权 401
   * @param status 状态码
   */

  var authrIntercept = function authrIntercept(status) {
    if (status === 401) {
      var _withTokenAxios = _getConfig('axios') || axios;
      var accessToken = getAccessToken();
      var dvaApp = getDvaApp();
      var language = getSession('language') || 'zh_CN'; // FIXME:已处理过一次401后就不再处理

      var cacheLocation = encodeURIComponent(window.location.toString());
      if (accessToken) {
        _withTokenAxios("".concat(HZERO_OAUTH, "/public/token/kickoff"), {
          method: 'POST',
          params: {
            access_token: accessToken
          }
        }).then(function (res) {
          if ((res === null || res === void 0 ? void 0 : res.kickoff) === 1) {
            // 跳转到踢下线界面
            // eslint-disable-next-line
            dvaApp._store.dispatch(routerRedux.push({
              pathname: '/public/kickoff',
              search: "?language=".concat(language)
            }));
            setSession('redirectUrl', cacheLocation);
            setSession('isErrorFlag', false);
          } else {
            // token 失效, 跳转到 token失效页面
            dvaApp._store.dispatch(routerRedux.push({
              pathname: '/public/unauthorized',
              search: "?language=".concat(language)
            }));
            setSession('isErrorFlag', true); // 登陆后需要跳回的界面， 放到session中

            setSession('redirectUrl', cacheLocation);
          }
        });
      }
      return false;
    }
    return true;
  };
  var jsonMimeType = 'application/json';
  var withTokenAxios = _getConfig('axios') || axios;
  if (!withTokenAxios._HZERO_AXIOS_IS_CONFIGED) {
    axios.interceptors.request.eject(0);
    axios.interceptors.response.eject(0); // 微前端模式下， 这个语句块会多次执行， 所以加一个条件限制， 只能执行一次

    withTokenAxios.defaults = _objectSpread({}, withTokenAxios.defaults, {
      headers: _objectSpread({}, (withTokenAxios.defaults || {}).headers, {
        // Authorization: `bearer ${getAccessToken()}`,
        'Content-Type': jsonMimeType,
        Accept: jsonMimeType,
        'X-Requested-With': 'XMLHttpRequest' // baseURL: API_HOST,
      }),

      withCredentials: true
    }); // Add a request interceptor

    withTokenAxios.interceptors.request.use(function (config) {
      var _config$url = config.url,
        url = _config$url === void 0 ? '' : _config$url;
      if (url.indexOf('://') === -1 && !url.startsWith('/_api')) {
        url = "".concat(API_HOST).concat(url);
      } // Do something before request is sent

      var MenuId = getMenuId(); // 添加额外的请求头

      var patchRequestHeaderConfig = getConfig('patchRequestHeader');
      var patchRequestHeader;
      if (patchRequestHeaderConfig) {
        if (typeof patchRequestHeaderConfig === 'function') {
          patchRequestHeader = patchRequestHeaderConfig();
        } else {
          patchRequestHeader = patchRequestHeaderConfig;
        }
      }
      if (MenuId) {
        return _objectSpread({}, config, {
          url: url,
          withCredentials: true,
          headers: _objectSpread({}, config.headers, {
            Authorization: "bearer ".concat(getAccessToken()),
            'H-Menu-Id': "".concat(getMenuId()),
            'H-Request-Id': "".concat(getRequestId())
          }, patchRequestHeader),
          paramsSerializer: function paramsSerializer(params) {
            return qs.stringify(params);
          }
        });
      } else {
        return _objectSpread({}, config, {
          url: url,
          withCredentials: true,
          headers: _objectSpread({}, config.headers, {
            Authorization: "bearer ".concat(getAccessToken()),
            'H-Request-Id': "".concat(getRequestId())
          }, patchRequestHeader),
          paramsSerializer: function paramsSerializer(params) {
            return qs.stringify(params);
          }
        });
      }
    }, function (error) {
      return (
        // Do something with request error
        Promise.reject(error)
      );
    });
    withTokenAxios.interceptors.response.use(function (response) {
      var status = response.status,
        data = response.data,
        url = response.config.url;
      if (!authrIntercept(status)) {
        return;
      }
      if (status === 204) {
        return undefined;
      } // 响应拦截

      var responseIntercept = getConfig('responseIntercept');
      if (responseIntercept) {
        if (typeof responseIntercept === 'function') {
          responseIntercept(url, status, data);
        }
      }
      if (data && data.failed) {
        throw data;
      } else if (data && data.detailsMessage) {
        notification.error({
          message: data === null || data === void 0 ? void 0 : data.detailsMessage,
          description: data === null || data === void 0 ? void 0 : data.description
        });
      } else {
        return data;
      }
    }, function (error) {
      var _error$response = error.response,
        data = _error$response.data,
        status = _error$response.status;
      if (status !== 401) {
        if (data && data.failed) {
          notification.error({
            message: data === null || data === void 0 ? void 0 : data.message,
            description: data === null || data === void 0 ? void 0 : data.description
          });
        } else if (data && data.detailsMessage) {
          notification.error({
            message: data === null || data === void 0 ? void 0 : data.detailsMessage,
            description: data === null || data === void 0 ? void 0 : data.description
          });
        }
        throw error;
      }
    });
    withTokenAxios._HZERO_AXIOS_IS_CONFIGED = true;
  }
  var customizedLoad = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(customizedCode) {
      var tenantId, userId, code, localCode, serializedCustomized, customized, res, remoteCustomized, newSerializedCustomized;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              tenantId = getCurrentOrganizationId();
              userId = getCurrentUserId();
              code = "table.customized.".concat(customizedCode);
              localCode = "".concat(code, ".").concat(tenantId, ".").concat(userId);
              serializedCustomized = localStorage.getItem(localCode);
              if (!serializedCustomized) {
                _context.next = 15;
                break;
              }
              _context.prev = 6;
              customized = JSON.parse(serializedCustomized);
              if (!(tenantId === 0 || Date.now() - customized.lastUpdateTime < 60 * 60000)) {
                _context.next = 10;
                break;
              }
              return _context.abrupt("return", customized);
            case 10:
              _context.next = 15;
              break;
            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](6);
              console.error(_context.t0);
            case 15:
              if (!(tenantId !== 0)) {
                _context.next = 32;
                break;
              }
              _context.prev = 16;
              _context.next = 19;
              return withTokenAxios({
                url: "".concat(HZERO_PLATFORM, "/v1/").concat(tenantId, "/personal-tables"),
                method: 'GET',
                params: {
                  code: code,
                  tenantId: tenantId,
                  userId: userId
                }
              });
            case 19:
              res = _context.sent;
              if (!(res && res.dataJson)) {
                _context.next = 25;
                break;
              }
              remoteCustomized = _objectSpread({}, JSON.parse(res.dataJson), {
                lastUpdateTime: Date.now()
              });
              newSerializedCustomized = JSON.stringify(remoteCustomized);
              localStorage.setItem(localCode, newSerializedCustomized);
              return _context.abrupt("return", remoteCustomized);
            case 25:
              _context.next = 31;
              break;
            case 27:
              _context.prev = 27;
              _context.t1 = _context["catch"](16);
              console.error(_context.t1);
              return _context.abrupt("return", {
                columns: {}
              });
            case 31:
              return _context.abrupt("return", {
                columns: {}
              });
            case 32:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[6, 12], [16, 27]]);
    }));
    return function customizedLoad(_x) {
      return _ref4.apply(this, arguments);
    };
  }();
  var customizedSave = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(customizedCode, customized) {
      var code, tenantId, userId, localCode, serializedCustomized;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              code = "table.customized.".concat(customizedCode);
              tenantId = getCurrentOrganizationId();
              userId = getCurrentUserId();
              localCode = "".concat(code, ".").concat(tenantId, ".").concat(userId);
              serializedCustomized = JSON.stringify(_objectSpread({}, customized, {
                lastUpdateTime: Date.now()
              }));
              localStorage.setItem(localCode, serializedCustomized);
              if (tenantId !== 0) {
                withTokenAxios({
                  url: "".concat(HZERO_PLATFORM, "/v1/").concat(tenantId, "/personal-tables"),
                  method: 'POST',
                  data: {
                    code: code,
                    tenantId: tenantId,
                    userId: userId,
                    dataJson: serializedCustomized
                  }
                }).then(function (res) {
                  if (res) {
                    console.log(res);
                  }
                }).catch(function (err) {
                  notification.error({
                    message: err === null || err === void 0 ? void 0 : err.message,
                    description: err === null || err === void 0 ? void 0 : err.description
                  });
                });
              }
            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function customizedSave(_x2, _x3) {
      return _ref5.apply(this, arguments);
    };
  }();
  var tableFilterAdapter = function tableFilterAdapter(props) {
    var data = props.config.data,
      type = props.type,
      searchCode = props.searchCode;
    var organizationId = getCurrentOrganizationId();
    switch (type) {
      case 'read':
        return {
          url: "".concat(HZERO_PLATFORM, "/v1/").concat(organizationId, "/search-config?searchCode=").concat(searchCode),
          method: 'get'
        };
      case 'create':
        return {
          url: "".concat(HZERO_PLATFORM, "/v1/").concat(organizationId, "/search-config"),
          method: 'post',
          data: data[0]
        };
      case 'update':
        return {
          url: "".concat(HZERO_PLATFORM, "/v1/").concat(organizationId, "/search-config/").concat(data[0].searchId),
          method: 'put',
          data: data[0]
        };
      case 'destroy':
        return {
          url: "".concat(HZERO_PLATFORM, "/v1/").concat(organizationId, "/search-config/").concat(data[0].searchId),
          data: data[0],
          method: 'delete'
        };
      default:
        return null;
    }
  };
  var defaultRenderEmpty = function defaultRenderEmpty(componentName) {
    switch (componentName) {
      case 'Attachment':
        return $l('Attachment', 'no_attachments');
      case 'Table':
        return /*#__PURE__*/React.createElement("div", {
          style: {
            textAlign: 'center'
          }
        }, /*#__PURE__*/React.createElement("img", {
          alt: "empty_page",
          src: noDataImg,
          width: "160",
          height: "160"
        }), /*#__PURE__*/React.createElement("p", null, intl.get('hzero.common.model.noData').d('暂无数据')));
      case 'Select':
        return $l('Select', 'no_matching_results');
      case 'Output':
        return '';
      default:
    }
  };
  _configure({
    tableBorder: true,
    ripple: false,
    modalOkFirst: false,
    lookupAxiosConfig: lookupAxiosConfig,
    lovDefineAxiosConfig: lovDefineAxiosConfig,
    lovQueryAxiosConfig: lovQueryAxiosConfig,
    lovQueryUrl: undefined,
    lookupUrl: undefined,
    lookupBatchAxiosConfig: lookupBatchAxiosConfig,
    lookupAxiosMethod: 'GET',
    dataKey: 'content',
    totalKey: 'totalElements',
    axios: withTokenAxios,
    generatePageQuery: generatePageQuery,
    status: {
      add: 'create',
      update: 'update',
      delete: 'delete'
    },
    // iconfontPrefix: 'c7n',
    statusKey: '_status',
    tlsKey: '_tls',
    useColon: true,
    queryBar: "professionalBar",
    tableFilterSearchText: 'keyword',
    pagination: {
      pageSizeEditable: true,
      pageSizeOptions: ['10', '20', '50', '100']
    },
    tableAutoHeightDiff: 100,
    modalMaskClosable: 'dblclick',
    modalAutoCenter: true,
    tableKeyboard: true,
    lovAutoSelectSingle: true,
    lovQueryBarProps: {
      autoQueryAfterReset: (configureParams === null || configureParams === void 0 ? void 0 : configureParams.autoQueryAfterReset) || true,
      fuzzyQuery: false
    },
    lovQueryBar: "filterBar",
    tableHighLightRow: "click",
    tableCustomizable: true,
    tableColumnDraggable: true,
    tableColumnTitleEditable: true,
    tableFilterAdapter: tableFilterAdapter,
    customizedLoad: customizedLoad,
    customizedSave: customizedSave,
    attachment: Attachment,
    renderEmpty: defaultRenderEmpty,
    feedback: {
      loadSuccess: function loadSuccess() {},
      loadFailed: function loadFailed(resp) {
        if (resp && resp.failed) {
          notification.autoNotification(resp === null || resp === void 0 ? void 0 : resp.type, resp === null || resp === void 0 ? void 0 : resp.message, resp.description);
        } else if (resp && resp.response) {
          if (!authrIntercept(resp.response.status)) {
            return;
          }
          if (resp.response.data && resp.response.data.detailsMessage) {
            var _resp$response$data;
            notification.error({
              message: resp.response.data.detailsMessage,
              description: (_resp$response$data = resp.response.data) === null || _resp$response$data === void 0 ? void 0 : _resp$response$data.description
            });
          } else {
            notification.error({
              message: resp === null || resp === void 0 ? void 0 : resp.message,
              description: resp === null || resp === void 0 ? void 0 : resp.description
            });
          }
        }
      },
      submitSuccess: function submitSuccess(resp) {
        notification.success({
          message: resp === null || resp === void 0 ? void 0 : resp.message,
          description: resp === null || resp === void 0 ? void 0 : resp.description
        });
      },
      submitFailed: function submitFailed(resp) {
        if (resp && resp.failed) {
          notification.autoNotification(resp === null || resp === void 0 ? void 0 : resp.type, resp === null || resp === void 0 ? void 0 : resp.message, resp.description);
        }
      }
    },
    transport: {
      tls: function tls(_ref6) {
        var _dataSet$current;
        var dataSet = _ref6.dataSet,
          fieldName = _ref6.name;

        // TODO: 先使用 dataSet.current 下个版本 c7n 会 把 record 传进来
        var _token = dataSet === null || dataSet === void 0 ? void 0 : (_dataSet$current = dataSet.current) === null || _dataSet$current === void 0 ? void 0 : _dataSet$current.get('_token');
        return {
          url: "".concat(HZERO_PLATFORM, "/v1/multi-language"),
          method: 'GET',
          params: {
            _token: _token,
            fieldName: fieldName
          },
          transformResponse: function transformResponse(data) {
            try {
              var jsonData = JSON.parse(data);
              if (jsonData && !jsonData.failed) {
                var tlsRecord = {};
                jsonData.forEach(function (intlRecord) {
                  tlsRecord[intlRecord.code] = intlRecord.value;
                });
                return [_defineProperty({}, fieldName, tlsRecord)];
              } else if (jsonData && jsonData.failed) {
                throw new Error(jsonData.message);
              }
            } catch (e) {
              // do nothing, use default error deal
              throw e;
            }
            return data;
          }
        };
      }
    }
  });
};
if (!window._ISLOADED_C7NUICONFIG) {
  loadConfig();
  window._ISLOADED_C7NUICONFIG = true;
}
export { lovDefineAxiosConfig, loadConfig };